import HTMLTemplate from './template.html'
import './styles.scss'
import User from '../../modules/user'

export const MyFleetPopupComponent = (() => {
    const vueComponent = {
        data() {
            return {
                leftPosition: 0,
                topPosition: 0,
                display: 'none',

                identifier: '', 
                aircraftName: '', // Doesn't come with the current API call, Rush will need to research, maybe some complete list of aircrafts with
                // basic information that we can call only once, so we don't need to map it with each request?
                origin: '',
                destination: '',
                originIATA: '',
                destinationIATA: '',
                landingTime: '', // Doesn't come with the current API call, Rush will need to research
                scheduledTime: '', // This looks like our arrival time from the API
                groundSpeedKilometers: '',
                groundSpeedMiles: '',
                altitudeMeters: '',
                altitudeFeet: '',
                directDistanceInKilometers: 0,
                directDistanceInMiles: 0,

                // Remember user settings preferences for the UI display
                userAirportCodePreference: 'ICAO', 
                mesaurementUnitsPreference: 'Metric'
            }
        },
        mounted() {
            this.subscribeToUserSettingsChanges()
        },
        methods: {
            subscribeToUserSettingsChanges () {
                // TODO: It would be nice to implement subscribe observable function on the user profile
                // For now we can achieve it with an interval which is fine and shouldn't cause memory leaks
                // https://stackoverflow.com/questions/14034107/does-javascript-setinterval-method-cause-memory-leak/14851513#14851513
                window.setInterval(() => {
                    this.userAirportCodePreference = User.userSettings.airportCode
                    this.mesaurementUnitsPreference = User.userSettings.mesaurementUnits
                }, 2500)
            }
        },
        template: HTMLTemplate
    }

    const DOMElement = document.getElementById('vue-my-fleet-popup')

    if (DOMElement === null) {
        return null
    } else {
        return Vue.createApp(vueComponent).mount(DOMElement)
    }
})();
